export function purifyString(input: string): string {
  // Remove <script> and <style> blocks entirely (tags + content)
  let text = input
    .replace(/<script[\s\S]*?<\/script>/gi, '')
    .replace(/<style[\s\S]*?<\/style>/gi, '');

  // Decode HTML entities (&lt; → <, &nbsp; → space, etc.)
  const decoder = document.createElement('textarea');
  decoder.innerHTML = text;
  text = decoder.value;

  // Collapse 3+ consecutive <br> tags into max 2
  text = text.replace(/(\s*<br\s*\/?>\s*){3,}/gi, '');

  // Strip all remaining HTML tags
  text = text.replace(/<[^>]*>/g, '');

  // Remove javascript: protocols and on* event attributes residue
  text = text.replace(/javascript:/gi, '').replace(/on\w+\s*=/gi, '');

  // Remove null bytes and control characters (except normal whitespace), but allow all Unicode
  text = text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g, '');

  return text.trim();
}
